import React, { Component } from 'react';
import timer_image from "../../assets/images/timer.png";

// --- Timer Display Component (Only this component re-renders) ---
class TimerView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeRemaining: 0,
      isTimerExpired: false,
    };
    this.localStorageKey = 'timerEndTime';
    // this.props.timerExpired(false);
    this.timerInterval = null;
  }

  initializeTimer() {
    const storedEndTime = localStorage.getItem(this.localStorageKey);
    const currentTime = Date.now();
    const fiveMinutesInMs = 5 * 60 * 1000;

    let endTime;

    if (storedEndTime) {
      endTime = parseInt(storedEndTime, 10);
      if (currentTime >= endTime) {
        this.setState({ timeRemaining: 0, isTimerExpired: true });
        // this.props.timerExpired(true);
        // console.log('timer-expired');
        localStorage.removeItem(this.localStorageKey);
        return;
      }
    } else {
      endTime = currentTime + fiveMinutesInMs;
      localStorage.setItem(this.localStorageKey, endTime.toString());
    }

    const initialRemainingTime = Math.max(0, Math.floor((endTime - currentTime) / 1000));
    this.setState({ timeRemaining: initialRemainingTime });
  }

  tick() {
    const currentTime = Date.now();
    const storedEndTime = localStorage.getItem(this.localStorageKey);

    if (!storedEndTime) {
        this.setState({ timeRemaining: 0, isTimerExpired: true });
        // this.props.timerExpired(true);
        // console.log('timer-expired-2');
        clearInterval(this.timerInterval);
        return;
    }

    const endTime = parseInt(storedEndTime, 10);
    const timeDifference = endTime - currentTime;

    if (timeDifference <= 0) {
      this.setState({ timeRemaining: 0, isTimerExpired: true });
      // this.props.timerExpired(true);
      // console.log('timer-expired-3');
      clearInterval(this.timerInterval);
      localStorage.removeItem(this.localStorageKey);
    } else {
      // Update state in the parent
      this.setState({ timeRemaining: Math.floor(timeDifference / 1000) });
    }
  }

  formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  startTimer = () => {
    this.initializeTimer();
    this.timerInterval = setInterval(() => this.tick(), 1000);
 }

  stopTimer = () => {
    this.setState({ timeRemaining: 0, isTimerExpired: true });
    // this.props.timerExpired(true);
    // console.log('timer-expired-4');
    clearInterval(this.timerInterval);
  }

  componentWillUnmount() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  render() {

    const { timeRemaining, isTimerExpired } = this.state;

    let timerColor = ''; // Default color
    if (timeRemaining < 60) {
      timerColor = 'red-timer';
    }

    let codeLeft = 'few';
    if (this.props.selectedOffer && this.props.selectedOffer.offerInventory) {
      codeLeft = this.props.selectedOffer.offerInventory;
    }

    return <div className={`checkout-timer ${timerColor}`}>
      <div>ONLY {codeLeft} CODE(S) LEFT AT THIS PRICE</div>
      {timeRemaining > 0 ? <div><img src={timer_image} /> {this.formatTime(timeRemaining)} REMAINING</div> : ''}
    </div>;
  }
}

export default TimerView;
